import { PFlexItem, PButton } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import { ReportingContext } from '../../utils/Context/ReportingContext'

import { PortalContext } from '../../utils/PortalContext'

import UserRatingIcon from '../../../shared/assets/UserRating_Icon_White.svg'
import styles from './content.module.css'

type Props = React.PropsWithChildren<{}>

const openInNewTab = () => {
  const newWindow = window.open(
    'https://userratingprod.z6.web.core.windows.net/?configId=0941e3e1-ee91-478d-96c8-0e013a553a68&appName=Porsche%20User%20Rating',
    '_blank',
    'noopener,noreferrer'
  )
  if (newWindow) newWindow.opener = null
}

const Content = ({ children }: Props) => {
  const { openDrawer } = React.useContext(PortalContext)
  const { openFilterMenu, setOpenFilterMenu } = React.useContext(ReportingContext)

  return (
    <PFlexItem className={clsx(styles.content, { [styles.openDrawer]: openDrawer })}>
      <PButton
        iconSource={UserRatingIcon}
        variant='primary'
        className={styles.feedbackBtn}
        onClick={() => openInNewTab()}
      >
        Feedback
      </PButton>

      {children}
    </PFlexItem>
  )
}

export default Content
